import Component from "@lib/Component.js";
import { addEvent, removeEvent } from "@qneyraud/q-utils";
import gsap from "gsap";

export default class RecruitmentForm extends Component {
  init() {
    super.init();
    this.bindMethods();
  }

  bindMethods() {
    // this.onSubmit = this.onSubmit.bind(this)
    this.onExpandButtonClick = this.onExpandButtonClick.bind(this);
  }

  onEnterCompleted() {
    // this.formComponent = this.getChildrenById('form')[0]
    // this.inputsComponents = this.formComponent.getChildrenById('input')
    // this.submitInputComponent = this.inputsComponents.find(input => input.datas.type === 'submit')
    // this.fieldsInputComponent = this.inputsComponents.filter(input => input.datas.type !== 'submit')

    this.initEvents();
  }

  onLeave() {
    super.onLeave();

    // removeEvent(this.refs['form'], 'submit', this.onSubmit)
    removeEvent(this.refs["expand-button"], "click", this.onExpandButtonClick);
  }

  initEvents() {
    // addEvent(this.refs['form'], 'submit', this.onSubmit)
    addEvent(this.refs["expand-button"], "click", this.onExpandButtonClick);
  }

  // onSubmit (e) {
  //   e.preventDefault()
  //   console.log(this.fieldsInputComponent);
  // }

  onExpandButtonClick() {
    gsap.to(this.refs.main, {
      duration: 0.6,
      ease: "power2.in",
      height: "auto"
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/RecruitmentForm.js